import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";

const COVERS = Array.from({ length: 40 }, (_, i) => `/wagram/wagram-${String(i + 1).padStart(2, "0")}.webp`);

export default function Wagram() {
  return (
    <main className="pt-32 sm:pt-36 pb-20 min-h-screen" data-testid="wagram-page">
      <section className="jm-container mb-14 sm:mb-20">
        <Reveal>
          <p className="jm-overline mb-5">Archives &amp; catalogue</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-jm-bone leading-[1.08] max-w-4xl">
            Nicolas Dri × <em className="italic text-jm-brass">Wagram Music</em>
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-jm-smoke leading-relaxed">
            À l'initiative de Joy Messenger, Nicolas Dri développe depuis de nombreuses années un travail de
            composition, d'arrangement et de réalisation musicale. Au fil de nombreuses collaborations éditoriales,
            il a notamment constitué un vaste catalogue pour Wagram Music, explorant différentes écritures
            instrumentales, musiques du monde et univers sonores destinés au « Chill », à la relaxation, mais aussi
            à l'édition et à l'image.
          </p>
          <p className="mt-4 max-w-2xl text-sm text-jm-mute">
            {COVERS.length} albums réalisés pour Wagram Music — les pochettes du catalogue, en archives.
          </p>
        </Reveal>
      </section>

      <section className="jm-container" data-testid="wagram-gallery">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {COVERS.map((src, i) => (
            <Reveal key={src} delay={0.03 * (i % 10)}>
              <div
                className="group relative aspect-square overflow-hidden border border-jm-brass/10 bg-jm-card"
                data-testid={`wagram-cover-${i + 1}`}
              >
                <img
                  src={src}
                  alt={`Album Wagram Music ${i + 1} — Nicolas Dri`}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-[transform,filter] duration-500 ease-out"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/20 pointer-events-none" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="jm-container mt-16 sm:mt-20">
        <Reveal>
          <div className="border-t border-jm-brass/10 pt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
            <p className="text-sm text-jm-smoke leading-relaxed max-w-xl">
              Ces musiques sont disponibles pour l'édition et la synchronisation. Réalisateurs, scénaristes,
              producteurs : pour explorer le catalogue ou obtenir une licence, écrivez-nous.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/contact"
                data-testid="wagram-contact-link"
                className="inline-flex items-center gap-2 border border-jm-brass/40 text-jm-bone px-6 py-3 text-xs uppercase tracking-[0.2em] hover:bg-jm-brass hover:text-jm-ink transition-colors"
              >
                Nous contacter <ArrowUpRight size={13} />
              </Link>
              <Link
                to="/editions"
                data-testid="wagram-back-link"
                className="inline-flex items-center gap-2 px-6 py-3 text-xs uppercase tracking-[0.2em] text-jm-mute hover:text-jm-bone transition-colors"
              >
                ← Créations
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
